import {
  Alert,
  Chip,
  Divider,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import GapsinBrandData from "./FTDLoadedAccordions/GapsinBrandData";
import ConversionLoadingFailures from "./FTDLoadedAccordions/ConversionLoadingFailures";
import MissingPlatformID from "./FTDLoadedAccordions/MissingPlatformID";
import LateConversions from "./FTDLoadedAccordions/LateConversions";
import UnpaidTrafficSource from "./FTDLoadedAccordions/UnpaidTrafficSource";
import AlternativePlatformIdentifiers from "./FTDLoadedAccordions/AlternativePlatformIdentifiers";
import ConversionsUploadComparison from "./FTDLoadedAccordions/ConversionsUploadComparison/ConversionsUploadComparison";
import FtdLoadedPieChart from "./FtdLoadedPieChart";
import MultiSegmentBar from "./ProgressChart";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectIsLoading,
  selectUserToken,
  selectUserWebsitePermissions,
  setIsLoading,
} from "../../../../../../features/userSlice";
import { trackPromise } from "react-promise-tracker";
import { useSearchParams } from "react-router-dom";
import { getAllDataForLoadedFromTotal } from "./helpers/loadedFromTotalHelpers";
import dayjs from "dayjs";
import SimpleBackdrop from "../../../../../BackDrop/BackDrop";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FtdLoadedPieChartB from "./FtdLoadedPieChartB";
import store from "../../../../../../store";

const FtdLoadedFromTotal = () => {
  const isLoading = useSelector(selectIsLoading);
  const authToken = useSelector(selectUserToken)?.toString();

  // getting values from URL
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedActionType = searchParams.get("selectedActionType") as string;
  const [selecteDate, setSelectedDate] = useState(
    searchParams.get("selecteDate")
  );
  const selectedSharedUidBuiURL = searchParams.get("selectedSharedUids") as any;
  const selectedDimensionsURL = searchParams.get("selectedDimension") as string;
  const selectedTypeURL = searchParams.get("selectedType") as string;
  const selectedAllURL = searchParams.get("selectedAll") as string;

  // checking if values appeares URL
  const websites = useSelector(selectUserWebsitePermissions) as any;

  //-- Get site name
  const siteLabels = websites
    ?.filter((item: any) => {
      const key = Object.keys(item)[0];
      return selectedSharedUidBuiURL?.split(",")?.includes(key);
    })
    ?.map((value: any) => {
      const key = Object.keys(value)[0];
      return value[key]?.site_name;
    });

  // states for accordions data
  const [loadedFromTotal, setLoadedFromTotal] = useState([]) as any;
  const [gapBrandData, setGapBrandData] = useState([]) as any;
  const [trafficSourceData, setTrafficSourceData] = useState([]) as any;
  const [platformIDdata, setPlatformIDdata] = useState([]) as any;
  const [lateConversionsData, setLateConversionsData] = useState([]) as any;
  const [loadingFailuresData, setLoadingFailuresData] = useState([]) as any;
  const [platformIdentifiersData, setPlatformIdentifiersData] = useState(
    []
  ) as any;
  const [uploadedToPlatformsData, setUploadedToPlatformsData] = useState(
    []
  ) as any;
  const [advertisingPlatformsData, setAdvertisingPlatformsData] = useState(
    []
  ) as any;

  const [rows, setRows] = useState([]) as any;
  const [, setGapcalculated] = useState<number>(0);
  const [dataSegmentsA, setDataSegmentsA] = useState([] as any);
  const [dataSegmentsB, setDataSegmentsB] = useState([] as any);

  const [updatedDataSegmentA, setUpdatedDataSegmentA] = useState([] as any);
  const [updatedDataSegmentB, setUpdatedDataSegmentB] = useState([] as any);

  const allReady =
    Object.keys(gapBrandData)?.length &&
    Object.keys(trafficSourceData)?.length &&
    Object.keys(platformIDdata)?.length &&
    Object.keys(lateConversionsData)?.length &&
    Object.keys(loadingFailuresData)?.length &&
    Object.keys(platformIdentifiersData)?.length &&
    loadedFromTotal?.query_output?.length > 0;

  useEffect(() => {
    if (loadedFromTotal?.query_output?.length >= 0) {
      setRows(loadedFromTotal?.query_output);
    }
  }, [loadedFromTotal]);

  useEffect(() => {
    if (allReady) {
      store.dispatch(setIsLoading(false));
      const totalConversion =
        loadedFromTotal?.query_output[0]?.total_conversion;

      const totalLoaded =
        loadedFromTotal?.query_output[0]?.total_conversion_loaded;

      const brandGap = gapBrandData?.query_output?.reduce(
        (sum: any, item: any) => sum + item.gap,
        0
      );

      const gap =
        totalConversion -
        (brandGap +
          trafficSourceData?.query_output?.length +
          platformIDdata?.query_output?.length +
          loadingFailuresData?.query_output?.length) -
        totalLoaded;

      setGapcalculated(gap);

      setDataSegmentsA([
        {
          label: "Gaps in Brand Data",
          count: brandGap,
          percent: ((brandGap / totalConversion) * 100)?.toFixed(2),
          color: "#6200EE",
        },
        {
          label: "Unpaid Traffic Source",
          count: trafficSourceData?.query_output?.length,
          percent: (
            (trafficSourceData?.query_output?.length / totalConversion) *
            100
          )?.toFixed(2),
          color: "#FF928A",
        },
        {
          label: "Missing Platform ID",
          count: platformIDdata?.query_output?.length,
          percent: (
            (platformIDdata?.query_output?.length / totalConversion) *
            100
          )?.toFixed(2),
          color: "#3CC3DF",
        },
        {
          label: "Conversion Loading Failures",
          count: loadingFailuresData?.query_output?.length,
          percent: (
            (loadingFailuresData?.query_output?.length / totalConversion) *
            100
          )?.toFixed(2),
          color: "#D7369C",
        },
        {
          label: "Investigation Required",
          count: gap,
          percent: ((gap / totalConversion) * 100)?.toFixed(2),
          color: "#EF5350",
        },
      ]);

      setDataSegmentsB([
        {
          label: "Normal Conversions",
          count:
            totalLoaded -
            lateConversionsData?.query_output?.length -
            platformIdentifiersData?.query_output?.length,
          percent: (
            ((totalLoaded -
              lateConversionsData?.query_output?.length -
              platformIdentifiersData?.query_output?.length) /
              totalConversion) *
            100
          )?.toFixed(2),
          color: "#6200EE",
        },
        {
          label: "Late Conversions",
          count: lateConversionsData?.query_output?.length,
          percent: (
            (lateConversionsData?.query_output?.length / totalConversion) *
            100
          )?.toFixed(2),
          color: "#FFAE4C",
        },
        {
          label: "Alternative Platform Identifiers",
          count: platformIdentifiersData?.query_output?.length,
          percent: (
            (platformIdentifiersData?.query_output?.length / totalConversion) *
            100
          )?.toFixed(2),
          color: "#537FF1",
        },
      ]);
    }
    // eslint-disable-next-line
  }, [allReady]);

  const getDataFromTotal = () => {
    if (
      selectedSharedUidBuiURL &&
      selectedDimensionsURL &&
      selectedTypeURL &&
      selectedAllURL &&
      selecteDate &&
      selectedActionType
    )
      getAllDataForLoadedFromTotal(
        [selectedSharedUidBuiURL],
        [selectedDimensionsURL],
        selectedTypeURL,
        selectedAllURL,
        selecteDate,
        authToken,
        trackPromise,
        setLoadedFromTotal,
        setGapBrandData,
        setTrafficSourceData,
        setPlatformIDdata,
        setLateConversionsData,
        setLoadingFailuresData,
        setPlatformIdentifiersData,
        setUploadedToPlatformsData,
        setAdvertisingPlatformsData,
        selectedActionType
      );
  };

  const resetStates = () => {
    // reseting states
    setGapBrandData([]);
    setTrafficSourceData([]);
    setPlatformIDdata([]);
    setLateConversionsData([]);
    setLoadingFailuresData([]);
    setPlatformIdentifiersData([]);
    setLoadedFromTotal([]);
    setDataSegmentsA([]);
    setDataSegmentsB([]);
    setUpdatedDataSegmentA([]);
    setUpdatedDataSegmentB([]);
    setUploadedToPlatformsData([]);
    setAdvertisingPlatformsData([]);
  };

  const handelClickedDate = (value: number) => {
    const newDate = dayjs(rows[0]?.day)
      .add(value, "day")
      .format("YYYY-MM-DD") as any;
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("selecteDate", newDate); // Set new value
    setSearchParams(updatedParams);
    setSelectedDate(newDate);
  };

  useEffect(() => {
    resetStates();
    getDataFromTotal();
    // eslint-disable-next-line
  }, [selecteDate]);

  useEffect(() => {
    if (
      Object.keys(uploadedToPlatformsData)?.length &&
      Object.keys(advertisingPlatformsData)?.length
    ) {
      store.dispatch(setIsLoading(false));
    }
  }, [uploadedToPlatformsData, advertisingPlatformsData]);

  useEffect(() => {
    if (dataSegmentsA?.length > 0) {
      setUpdatedDataSegmentA(dataSegmentsA);
    }
  }, [dataSegmentsA]);

  useEffect(() => {
    if (dataSegmentsB?.length > 0) {
      setUpdatedDataSegmentB(dataSegmentsB);
    }
  }, [dataSegmentsB]);

  return (
    <>
      {isLoading && <SimpleBackdrop />}
      <>
        <Paper sx={{ padding: "8px 16px 16px", mt: 1 }}>
          {rows?.length > 0 ? (
            <>
              <Grid container spacing={4} minHeight={86}>
                <Grid size={8}>
                  <Box>
                    <Stack direction={"row"} gap={2} alignItems={"center"}>
                      <Typography variant="h5">
                        % of {selectedActionType?.toLocaleUpperCase()} loaded
                        from total
                      </Typography>
                      {/* date navigator */}
                      <Stack
                        direction={"row"}
                        gap={1}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <Tooltip title="Previous Day">
                          <IconButton //previous date
                            data-tracker="454"
                            onClick={() => handelClickedDate(-1)}
                            size="small"
                          >
                            <KeyboardArrowLeftIcon sx={{ fontSize: 35 }} />
                          </IconButton>
                        </Tooltip>
                        <Typography fontSize={24}>
                          {dayjs(rows[0]?.day).format("DD-MM-YYYY")}
                        </Typography>
                        <Tooltip title="Next Day">
                          <IconButton //next date
                            data-tracker="454"
                            onClick={() => handelClickedDate(1)}
                            size="small"
                          >
                            <KeyboardArrowRightOutlinedIcon
                              sx={{ fontSize: 35 }}
                            />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                      <Stack direction="row" spacing={1}>
                        {siteLabels?.map((site: any) => {
                          return (
                            <Chip
                              key={site}
                              label={site}
                              sx={{
                                bgcolor: "secondary.dark",
                                color: "white",
                                height: "26px",
                              }}
                            />
                          );
                        })}
                      </Stack>
                    </Stack>
                    <Typography variant="body2" color="text.secondary">
                      Here you will find a step by step breakdown of{" "}
                      {selectedActionType?.toLocaleUpperCase()}'s that were
                      loaded back into the ads platform.
                      <br /> At any point in the funnel, you'll be able to see
                      How many deposits were lost due to the specific reasoning,
                      in addition, you’ll get all deposit details at the player
                      level.
                    </Typography>
                  </Box>
                </Grid>
                <Grid size={4}>
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-end"
                    sx={{ height: "100%" }}
                  >
                    {/* <Stack direction={"row"} gap={1} alignContent={"center"}>
                      <FlagCircleOutlinedIcon
                        sx={{ color: "rgba(211, 47, 47, 1)" }}
                      />
                      <Typography variant="subtitle1">
                        Gaps that requires investigation: {GapCalculated}
                      </Typography>
                    </Stack> */}
                  </Stack>
                </Grid>
              </Grid>
            </>
          ) : (
            <Alert
              sx={{ color: "#ED6C02", mb: 1 }}
              severity="warning"
              icon={<InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />}
            >
              NO DATA
            </Alert>
          )}
        </Paper>
        <Divider sx={{ marginBlock: "10px" }} />
        <Paper sx={{ mb: 2 }}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Stack direction={"column"} sx={{ padding: "16px" }}>
                <Typography variant="h5" mb={1}>
                  Unloaded Conversions Breakdown
                </Typography>
                <Stack direction={"row"} gap={8} alignItems={"center"}>
                  {rows?.length > 0 ? (
                    <FtdLoadedPieChart
                      loadedPerc={
                        rows?.[0]?.perc_conversions_loaded
                          ? rows[0].perc_conversions_loaded.toFixed(2) * 100
                          : 0
                      }
                      loadedCount={rows?.[0]?.total_conversion_loaded ?? 0}
                      totalLoaded={rows?.[0]?.total_conversion ?? 0}
                      selectedActionType={selectedActionType?.toLocaleUpperCase()}
                    />
                  ) : (
                    <Alert
                      sx={{ color: "#ED6C02", mb: 1 }}
                      severity="warning"
                      icon={
                        <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />
                      }
                    >
                      NO DATA
                    </Alert>
                  )}

                  {Object.values(updatedDataSegmentA)?.length > 0 ? (
                    <MultiSegmentBar
                      dataSegments={updatedDataSegmentA}
                      selectedType={selectedActionType?.toLocaleUpperCase()}
                    />
                  ) : (
                    ""
                  )}
                </Stack>
              </Stack>
              <GapsinBrandData
                rows={gapBrandData?.query_output}
                total={rows[0]?.total_conversion}
              />
              <UnpaidTrafficSource
                rows={trafficSourceData?.query_output}
                selecteDate={selecteDate}
                total={rows[0]?.total_conversion}
              />
              <MissingPlatformID
                rows={platformIDdata?.query_output}
                selecteDate={selecteDate}
                total={rows[0]?.total_conversion}
              />
              <ConversionLoadingFailures
                rows={loadingFailuresData?.query_output}
                selecteDate={selecteDate}
                total={rows[0]?.total_conversion}
              />
            </Grid>
          </Grid>
        </Paper>
        <Paper sx={{ mb: 2 }}>
          <Grid container spacing={2}>
            <Grid size={12}>
              {/* please change this part as i copied it from unloaded part as the design is same*/}
              <Stack direction={"column"} sx={{ padding: "16px" }}>
                <Typography variant="h5" mb={1}>
                  Loaded Conversions Breakdown
                </Typography>
                <Stack direction={"row"} gap={8} alignItems={"center"}>
                  {rows?.length > 0 ? (
                    // Please make a new component for this
                    <FtdLoadedPieChartB
                      loadedCount={rows?.[0]?.total_conversion_loaded ?? 0}
                      totalConversion={rows?.[0]?.total_conversion ?? 0}
                      selectedActionType={selectedActionType}
                      altIdentifier={
                        platformIdentifiersData?.query_output?.length
                      }
                      late={lateConversionsData?.query_output?.length}
                    />
                  ) : (
                    <Alert
                      sx={{ color: "#ED6C02", mb: 1 }}
                      severity="warning"
                      icon={
                        <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />
                      }
                    >
                      NO DATA
                    </Alert>
                  )}

                  {Object.values(updatedDataSegmentB)?.length > 0 ? (
                    <MultiSegmentBar
                      dataSegments={updatedDataSegmentB}
                      selectedType={selectedActionType?.toLocaleUpperCase()}
                    />
                  ) : (
                    ""
                  )}
                </Stack>
              </Stack>
              <LateConversions
                rows={lateConversionsData?.query_output}
                selecteDate={selecteDate}
                total={rows[0]?.total_conversion}
              />
              <AlternativePlatformIdentifiers
                rows={platformIdentifiersData?.query_output}
                selecteDate={selecteDate}
                total={rows[0]?.total_conversion}
              />
            </Grid>
          </Grid>
        </Paper>
        <Paper sx={{ mt: 2 }}>
          <ConversionsUploadComparison
            uploadedToPlatformsData={uploadedToPlatformsData?.query_output}
            advertisingPlatformsData={advertisingPlatformsData?.query_output}
            selecteDate={selecteDate}
          />
        </Paper>
        {/* <DetailedPlayerLevel
          rows={loadingFailuresData?.query_output}
          total={rows[0]?.total_conversion}
        /> */}
      </>
    </>
  );
};

export default FtdLoadedFromTotal;
